(function (angular) {
    'use strict';

    angular.module('app.landing').config([
        '$stateProvider',
        '$urlRouterProvider',
        function ($stateProvider) {
            $stateProvider
                .state('app.welcome', {
                    url: '/welcome',
                    controller: [
                        '$state',
                        function ($state) {
                            $state.go('app.landing');
                        }
                    ]
                })
                .state('app.home', {
                    url: '',
                    controller: [
                        '$state',
                        function ($state) {
                            $state.go('app.landing');
                        }
                    ]
                })
                .state('app.redirect', {
                    url: '/redirect',
                    templateUrl: '/app/layout/main.html',
                    controller: ['$state', function ($state) { }]
                })
                .state('app.offline', {
                    url: '/offline',
                    templateUrl: '/app/offline/offline.html',
                    controller: ['$state', function ($state) { }]
                })
                .state('app.plus', {
                    url: '/plus',
                    controller: [
                        '$state',
                        function ($state) {
                            $state.go('app.landing');
                        }
                    ]
                })
                .state('app.landing', {
                    url: '/',
                    templateUrl: '/app/site/landing-flow/welcome/welcome.template.html',
                    controller: 'app.landing.welcomeController',
                    controllerAs: 'vmWelcomeController'
                });
        }
    ]);
})(angular);
